import React, {useEffect, useState} from 'react';
import './style.scss';

const HamburgerButton = ({ onClick, showNav }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = () => {
        setIsOpen(!isOpen);
        if (onClick) {
            onClick();
        }
    };

    return (
        <button className={`hamburger_button ${showNav ? 'open' : ''}`} onClick={handleClick}>
            <svg id="hamburger" className={`hamburger ${showNav ? 'open' : ''}`} viewBox="0 0 60 40">
                <g stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                    <path id="top-line" d="M10,10 L50,10 Z"></path>
                    <path id="middle-line" d="M10,20 L50,20 Z"></path>
                    <path id="bottom-line" d="M10,30 L50,30 Z"></path>
                </g>
            </svg>
        </button>
    );
};

export default HamburgerButton;
